// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../graphql/api/index';

export const ReviewsAggregateFragmentDoc = `
    fragment reviewsAggregate on ReviewsAggregate {
  rating
  total
}
    `;